import { useState } from "react";
import { Loader2, Lock } from "lucide-react";
import { http, errText, money } from "../lib/api";

export const BuyButton = ({ product, quantity = 1, className = "", testId = "buy-now-button" }) => {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");
  const total = (product?.price ?? 30) * quantity + (product?.shipping ?? 0);
  const soldOut = (product?.stock ?? 1) <= 0;

  const buy = async () => {
    setLoading(true);
    setError("");
    try {
      const { data } = await http.post("/payments/checkout", { quantity, origin_url: window.location.origin });
      if (data?.checkout_url) window.location.href = data.checkout_url;
    } catch (e) {
      setError(errText(e));
      setLoading(false);
    }
  };

  return (
    <div className={className}>
      <button
        onClick={buy}
        disabled={loading || soldOut}
        data-testid={testId}
        className="group relative w-full overflow-hidden bg-[#E10600] text-white px-8 py-5 font-display uppercase text-2xl tracking-wide flex items-center justify-center gap-3 shadow-[8px_8px_0_#0B0B0B] transition-[transform,box-shadow] duration-200 hover:-translate-y-1 hover:shadow-[10px_12px_0_#0B0B0B] active:translate-y-0 active:shadow-[4px_4px_0_#0B0B0B] disabled:opacity-60"
      >
        <span className="absolute inset-0 bg-[#0B0B0B] translate-y-full transition-transform duration-300 group-hover:translate-y-0" />
        <span className="relative flex items-center gap-3">
          {loading ? <Loader2 className="w-5 h-5 animate-spin" /> : <Lock className="w-5 h-5" />}
          {soldOut ? "Sold out" : `Buy now — ${money(total)}`}
        </span>
      </button>
      {error && <p data-testid="checkout-error" className="mt-3 text-sm font-semibold text-[#E10600]">{error}</p>}
    </div>
  );
};
